export function isNil(data) {
    return data == null;
}
